import type { PageRequest } from '@/models/listPage';

export interface ExportListFilters {
  /** Inutilisée (pas de recherche) : requise par useListControls */
  search: string;
  /** Référence du type (SUMMARY…) ; null : tous */
  exportType: string | null;
  /** Référence du statut (COMPLETED…) ; null : tous */
  exportStatus: string | null;
}

/** Filtres à l'arrivée sur la page Exports : aucun */
export const DEFAULT_EXPORT_FILTERS: ExportListFilters = { search: '', exportType: null, exportStatus: null };

/**
 * Requête GET /exports d'une page de la liste : les exports de la société sélectionnée, du plus récent au plus ancien,
 * d'un type ou d'un statut. null : pas Dirigeant de la société (aucun export à lire).
 */
export function buildExportListRequest(
  companyId: number | null,
  { exportType, exportStatus }: ExportListFilters,
  page: number,
  itemsPerPage: number,
  /** Id API d'une référence (listes chargées depuis l'API) */
  typeId: (reference: string) => number | null = () => null,
  statusId: (reference: string) => number | null = () => null,
): PageRequest | null {
  if (!companyId) return null;

  return {
    filters: {
      company: companyId,
      exportType: exportType ? typeId(exportType) : null,
      exportStatus: exportStatus ? statusId(exportStatus) : null,
    },
    order: { createdAt: 'desc', id: 'desc' },
    page,
    itemsPerPage,
  };
}
